module.exports = __webpack_public_path__ + "img/country-southsudan.144855ef.svg";